import type { ButtonHTMLAttributes } from 'react';

const CLOSE_ICON = (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
);

const BACK_ICON = (
  <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
  </svg>
);

type RoundIconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children?: React.ReactNode;
};

export const RoundIconButton = ({ children, className, ...props }: RoundIconButtonProps) => (
  <button
    type="button"
    className={`flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 transition hover:border-slate-300 hover:bg-slate-50 ${className ?? ''}`}
    {...props}
  >
    {children}
  </button>
);

export const CloseButton = (props: Omit<RoundIconButtonProps, 'children'>) => (
  <RoundIconButton aria-label="Fechar" {...props}>{CLOSE_ICON}</RoundIconButton>
);

export const BackButton = (props: Omit<RoundIconButtonProps, 'children'>) => (
  <RoundIconButton aria-label="Voltar" {...props}>{BACK_ICON}</RoundIconButton>
);
